import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import './app/styles/globals.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container missing in index.html');
}

/**
 * In development a mock worker answers the patient booking endpoints, which the
 * unbuilt Booking context does not serve yet; the admin panel goes to the real
 * backend through the Vite proxy. Set VITE_MOCK_API=0 to disable mocking
 * entirely, or VITE_MOCK_ADMIN=1 to mock the admin routes as well (see
 * app/mocks/browser.ts). Production never reaches this branch at all.
 */
async function startMockApi(): Promise<void> {
  if (!import.meta.env.DEV || import.meta.env.VITE_MOCK_API === '0') {
    return;
  }

  const { worker } = await import('./app/mocks/browser');

  await worker.start({ onUnhandledRequest: 'bypass', quiet: true });
}

void startMockApi().then(() => {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
